import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { useAuthStore } from "../../../console/store/useAuthStore";
import { enum_api_uri } from "../utils/enum";

interface PaymentReasonData {
    payment_order: number;
    payment_name: string;
}

interface GetPaymentReasonResponse {
    data: PaymentReasonData[];
}

export const useGetCommonPayMethod = ({
    payment_category,
}: {
    payment_category: number;
}): UseQueryResult<GetPaymentReasonResponse, Error> => {
    const accessToken = useAuthStore(state => state.accessToken);

    return useQuery<GetPaymentReasonResponse, Error>({
        queryKey: ["getCommonPayMethod"],
        queryFn: async () => {
            const response = await axios.get(
                `${enum_api_uri.common_get_pay_method.replace(":payment_category", payment_category.toString())}`,
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                },
            );
            return response.data;
        },
    });
};
